import moment from 'moment';
import { dayIsInPast } from './utils';


const COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

function isEmpty(val){
  return !val || val.length === 0;
}


export function validateBrand(brand){
  const validationMessages = {};

  if(isEmpty(brand.agencyId)){
    validationMessages['agencyId'] = 'Agency is required';
  }

  if(isEmpty(brand.name)){
    validationMessages['name'] = 'Name is required';
  }

  if(isEmpty(brand.logoURL)){
    validationMessages['logoURL'] = 'Logo is required';
  }

  if(isEmpty(brand.logoFileName)){
    validationMessages['logoFileName'] = 'Logo is required';
  }

  if(isEmpty(brand.primaryColor)){
    validationMessages['primaryColor'] = 'Primary color is required';
  }

  if(!COLOR_REGEX.test(brand.primaryColor)){
    validationMessages['primaryColor'] = 'Primary color is invalid';
  }

  return validationMessages;
}

export function validateAgency(agency){
  const validationMessages = {};

  if(isEmpty(agency.name)){
    validationMessages['name'] = 'Name is required';
  }

  return validationMessages;
}

export function validateCampaign(campaign){
  const validationMessages = {};

  if(isEmpty(campaign.name)){
    validationMessages['name'] = 'Name is required';
  }

  if(isEmpty(campaign.lifetimeBudget)){
    validationMessages['lifetimeBudget'] = 'Budget is required';
  }

  if(campaign.lifetimeBudget > 0 && campaign.lifetimeBudget < 50){
    validationMessages['lifetimeBudget'] = 'Budget must be at least 50';
  }

  if(isEmpty(campaign.launchDate)){
    validationMessages['launchDate'] = 'Launch date is required';
  }

  if(dayIsInPast(campaign.launchDate)){
    validationMessages['launchDate'] = 'Launch date can not be in the past';
  }

  if(campaign.endDate && moment(campaign.endDate).isBefore(campaign.launchDate)){
    validationMessages['endDate'] = 'End date can not be before launch date';
  }

  if(isEmpty(campaign.feedImageURL)){
    validationMessages['feedImageURL'] = 'Cover image is required';
  }

  if(isEmpty(campaign.feedImageFileName)){
    validationMessages['feedImageFileName'] = 'Cover image is required';
  }

  if(isEmpty(campaign.completionText)){
    validationMessages['completionText'] = 'Completion text is required';
  }

  validationMessages['tags'] = validateTags(campaign.tags);

  if(validationMessages['tags'].every((o) => o.length === 0)){
    delete validationMessages['tags'];
  }

  return validationMessages;
}

export function validateChooseEngagement(engagement){
  const validationMessages = {options:[]};

  if(isEmpty(engagement.text)){
    validationMessages['text'] = 'Multiple choice question is required';
  }

  if(isEmpty(engagement.firstImageId)){
    validationMessages['firstImageId'] = 'Multiple Choice image is required';
  }

  if(isEmpty(engagement.firstImageURL)){
    validationMessages['firstImageURL'] = 'Multiple Choice image is required';
  }

  if(isEmpty(engagement.firstImageFileName)){
    validationMessages['firstImageFileName'] = 'Multiple Choice image is required';
  }

  if(engagement.options.length < 2){
    validationMessages['allOptions'] = 'At least 2 choices are required';
  }

  if(engagement.options.length > 4){
    validationMessages['allOptions'] = 'Can not have more than 4 choices';
  }

  engagement.options.forEach((option, index) => {
    if(isEmpty(option.answer)){
      validationMessages['options'][index] = 'Multiple choice text is required';
    } else {
      validationMessages['options'][index] = '';
    }
  });

  if(validationMessages['options'].every((o) => o.length === 0)){
    delete validationMessages['options'];
  }

  validationMessages['firstTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'first'));

  if(validationMessages['firstTags'].every((o) => o.length === 0)){
    delete validationMessages['firstTags'];
  }


  return validationMessages;
}


export function validateRatableEngagement(engagement){
  const validationMessages = {};

  if(isEmpty(engagement.text)){
    validationMessages['text'] = 'Video intro text required';
  }

  if(isEmpty(engagement.videoId)){
    validationMessages['videoId'] = 'Video is required';
  }

  if(isEmpty(engagement.videoURL)){
    validationMessages['videoURL'] = 'Video is required';
  }

  if(isEmpty(engagement.videoFileName)){
    validationMessages['videoFileName'] = 'Video is required';
  }

  validationMessages['firstTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'first'));

  if(validationMessages['firstTags'].every((o) => o.length === 0)){
    delete validationMessages['firstTags'];
  }

  return validationMessages;
}


export function validateThisOrThatEngagement(engagement){
  const validationMessages = {};

  if(isEmpty(engagement.firstImageId)){
    validationMessages['firstImageId'] = 'First image is required';
  }

  if(isEmpty(engagement.firstImageURL)){
    validationMessages['firstImageURL'] = 'First image is required';
  }

  if(isEmpty(engagement.firstImageURL)){
    validationMessages['firstImageFileName'] = 'First image is required';
  }

  if(isEmpty(engagement.firstImageTitle)){
    validationMessages['firstImageTitle'] = 'First image title is required';
  }

  if(isEmpty(engagement.secondImageId)){
    validationMessages['secondImageId'] = 'Second image is required';
  }

  if(isEmpty(engagement.secondImageURL)){
    validationMessages['secondImageURL'] = 'Second image is required';
  }

  if(isEmpty(engagement.secondImageFileName)){
    validationMessages['secondImageFileName'] = 'Second image is required';
  }

  if(isEmpty(engagement.secondImageTitle)){
    validationMessages['secondImageTitle'] = 'Second image title is required';
  }

  validationMessages['firstTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'first'));

  if(validationMessages['firstTags'].every((o) => o.length === 0)){
    delete validationMessages['firstTags'];
  }

  validationMessages['secondTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'second'));

  if(validationMessages['secondTags'].every((o) => o.length === 0)){
    delete validationMessages['secondTags'];
  }


  return  validationMessages;
}

export function validateQAEngagement(engagement){
 const validationMessages = {options:[]};

  if(isEmpty(engagement.text)){
    validationMessages['text'] = 'Question is required';
  }

  if(isEmpty(engagement.firstImageId)){
    validationMessages['firstImageId'] = 'Question image is required';
  }

  if(isEmpty(engagement.firstImageURL)){
    validationMessages['firstImageURL'] = 'Question image is required';
  }

  if(isEmpty(engagement.firstImageFileName)){
    validationMessages['firstImageFileName'] = 'Question image is required';
  }

  if(engagement.options.length < 2){
    validationMessages['allOptions'] = 'At least 2 options are required';
  }

  if(engagement.options.length > 4){
    validationMessages['allOptions'] = 'Can not have more than 4 options';
  }

  if(isEmpty(engagement.correctAnswerId)){
    validationMessages['correctAnswerId'] = 'Please select the correct answer';
  }

  if(isEmpty(engagement.correctAnswerText)){
    validationMessages['correctAnswerText'] = 'Correct answer details required';
  }

  if(isEmpty(engagement.secondImageURL)){
    validationMessages['secondImageURL'] = 'Correct answer image is required';
  }

  if(isEmpty(engagement.secondImageFileName)){
    validationMessages['secondImageFileName'] = 'Correct answer image is required';
  }

  engagement.options.forEach((option, index) => {
    if(isEmpty(option.answer)){
      validationMessages['options'][index] = 'Option text is required';
    } else if(option.answer && option.answer.length > 70){
      validationMessages['options'][index] = 'Option text must be less than 70 characters';
    } else {
      validationMessages['options'][index] = '';
    }
  });

  if(validationMessages['options'].every((o) => o.length === 0)){
    delete validationMessages['options'];
  }

  validationMessages['firstTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'first'));

  if(validationMessages['firstTags'].every((o) => o.length === 0)){
    delete validationMessages['firstTags'];
  }

  validationMessages['secondTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'second'));

  if(validationMessages['secondTags'].every((o) => o.length === 0)){
    delete validationMessages['secondTags'];
  }

  return validationMessages;
}


export function validatePuzzleEngagement(engagement){
  const validationMessages = {options:[]};

  if(isEmpty(engagement.firstImageId)){
    validationMessages['firstImageId'] = 'Puzzle image is required';
  }

  if(isEmpty(engagement.firstImageURL)){
    validationMessages['firstImageURL'] = 'Puzzle image is required';
  }

  if(isEmpty(engagement.firstImageFileName)){
    validationMessages['firstImageFileName'] = 'Puzzle image is required';
  }

  if(isEmpty(engagement.text)){
    validationMessages['text'] = 'Title is required';
  }

  validationMessages['firstTags'] = validateTags((engagement.tags || []).filter((t) => t.type === 'first'));

  if(validationMessages['firstTags'].every((o) => o.length === 0)){
    delete validationMessages['firstTags'];
  }

  return validationMessages;
}

export function validateSegment(segment,otherSegments){
  const validationMessages = {};

  if(isEmpty(segment.name)){
    validationMessages['name'] = 'Name is required';
  }

  if(isEmpty(segment.retailerId)){
    validationMessages['retailerId'] = 'Retailer is required';
  }

  if(isEmpty(segment.activeFrom)){
    validationMessages['activeFrom'] = 'Start date is required';
  }

  if(isEmpty(segment.activeTo)){
    validationMessages['activeTo'] = 'End date is required';
  }

  if(segment.activeTo && moment(segment.activeTo).isBefore(segment.activeFrom)){
    validationMessages['activeFrom'] = 'End date can not be before launch date';
  }

  if(dayIsInPast(segment.activeTo)){
    validationMessages['activeTo'] = 'End date can not be in the past';
  }

  if(!segment.testPopPercent || segment.testPopPercent === 0){
    validationMessages['testPopPercent'] = 'Test population percent must be more than 0';
  }

  if(!segment.testPopNumSegment || segment.testPopNumSegment === 0){
    validationMessages['testPopPercent'] = 'Number of test segments must be more than 0';
  }

  if(segment.testPopNumSegment && segment.testPopNumSegment % 2 !== 0){
    validationMessages['testPopPercent'] = 'Must test an even number of segments';
  }

  return validationMessages;
}

export function validateBillingAddress(address){
  const validationMessages = {};

  if(isEmpty(address.name)){
    validationMessages['name'] = 'Name is required';
  }

  if(isEmpty(address.address_city)){
    validationMessages['address_city'] = 'City is required';
  }

  if(isEmpty(address.address_line1)){
    validationMessages['address_line1'] = 'Address is required';
  }

  if(isEmpty(address.address_state)){
    validationMessages['address_state'] = 'State is required';
  }

  if(isEmpty(address.address_zip)){
    validationMessages['address_zip'] = 'Zip code is required';
  }

  if(address.address_zip && (address.address_zip.length !== 5 || isNaN(parseInt(address.address_zip,10)))){
    validationMessages['address_zip'] = 'Zip code is invalid';
  }

  return validationMessages;
}


export function validateTags(tags){
  const validationMessages = [];

  if(!tags || tags.length === 0){
    return [];
  }

  tags.forEach((tag, index) => {
    if(isEmpty(tag.tag)){
      validationMessages[index] = 'Tag details required';
    } else {
      validationMessages[index] = '';
    }
  });

  return validationMessages;
}




// WEBPACK FOOTER //
// ./src/shared/validators.js